import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ChipTheme } from './interfaces';

@Component({
  selector: 'fcom-chip-button',
  styleUrls: ['chip-button.component.scss'],
  templateUrl: 'chip-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipButtonComponent {
  public readonly ChipTheme = ChipTheme;

  @Input()
  text: string;

  @Input()
  title: string;

  @Input()
  iconName: string;

  @Input()
  iconCategory = 'svg-library';

  @Input()
  theme: ChipTheme = ChipTheme.DEFAULT;

  @Input()
  disabled = false;

  @Output()
  chipClicked: EventEmitter<Event> = new EventEmitter<Event>();

  @Output()
  blur: EventEmitter<Event> = new EventEmitter<Event>();
}
